import {v4 as uuidv4} from 'uuid';
import {getEnv} from '../../common/env/env';
import {HelixSeriesDto} from '../../common/shared/api/nicolas/vo/HelixSeriesDto.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {AgeGrade, BadgeType, HelixSeries} from '../generated/types';

export function createHelixSeries(
  {
    series_id,
    title,
    ticket_count,
    thumbnail_url,
    scheme,
    category,
    view_count,
    left_badge_list,
    right_badge_list,
    item_order,
    sub_category,
  }: HelixSeriesDto,
  helixSeed: number
): HelixSeries {
  const {
    ageGrade,
    badge: ageGradeBadge,
    selfCensorship,
  } = getAgeGradeInfo(right_badge_list?.[0]);

  return {
    id: uuidv4(),
    seriesId: series_id,
    title,
    ticketCount: ticket_count,
    thumbnailUrl:
      thumbnail_url &&
      getKageUrl({
        kageUrlPrefix: getEnv().kageUrlPrefix,
        kageId: thumbnail_url,
        resolution: 'th3',
      }),
    scheme,
    category,
    viewCount: view_count,
    badgeList:
      left_badge_list?.map(badge => LeftBadgeListMap[badge]).filter(Boolean) ||
      [],
    ageGradeBadge,
    ageGrade,
    selfCensorship,
    itemOrder: item_order,
    subCategory: sub_category,
    eventLog: {
      eventMeta: {
        id: String(series_id),
        type: 'seriesId',
        name: title,
        category,
        subcategory: sub_category,
        provider: 'helix',
        series: title,
        series_id: String(series_id),
      },
      click: {
        layer1: '섹션',
        ordnum: String(item_order),
        imp_id: 'helix_landing',
        imp_provider: 'helix',
      },
      customProps: {
        landing_path: 'contents',
        helix_yn: 'y',
        helix_seed: String(helixSeed),
      },
      viewimp_contents: {
        imp_id: 'helix_landing',
        imp_provider: 'helix',
        imp_type: 'vimp',
        imp_ordnum: String(item_order),
        layer1: '헬릭스 랜딩리스트',
        id: String(series_id),
        type: 'seriesId',
      },
    },
  };
}

const LeftBadgeListMap: {
  [key: string]: BadgeType;
} = {
  WAITFREE: BadgeType.BadgeWaitFreeStatic,
  WAITFREE_3H: BadgeType.Badge3HourWaitfreeStatic,
  FREE: BadgeType.BadgeRealFreeStatic,
  UP: BadgeType.BadgeUpStatic,
  NEW: BadgeType.BadgeNewStatic,
  WAITFREE_0H: BadgeType.Badge0HourWaitfreeStatic,
  WAITFREE_1H: BadgeType.BadgeWaitFreeStatic,
  WAITFREE_2H: BadgeType.Badge2HourWaitfreeStatic,
};

function getAgeGradeInfo(rightBadge?: string) {
  if (rightBadge === 'AGE_15') {
    return {
      badge: BadgeType.BadgeAge15Static,
      ageGrade: AgeGrade.Fifteen,
      selfCensorship: false,
    };
  } else if (rightBadge === 'AGE_19') {
    return {
      badge: BadgeType.BadgeAge19Static,
      ageGrade: AgeGrade.Nineteen,
      selfCensorship: false,
    };
  } else if (rightBadge === 'SELF_CENSORSHIP') {
    return {
      badge: BadgeType.BadgeAge19CensorshipStatic,
      ageGrade: AgeGrade.Nineteen,
      selfCensorship: true,
    };
  }
  return {
    badge: undefined,
    ageGrade: undefined,
    selfCensorship: false,
  };
}
